<template>
    <div>
        <van-sticky>
<!--            <van-nav-bar-->
<!--                    title="行情资讯"-->
<!--                    left-text=""-->
<!--                    left-arrow-->
<!--                    @click-left="back()"-->
<!--            />-->
            <van-search
                    v-model="key"
                    show-action
                    placeholder="标题/资讯内容"
                    @search="onSearch"
                    clearable
                    left-icon=""
            >
                <template #action>
                    <div @click="onSearch">
                        <van-icon name="search" size="1.5rem" style="vertical-align: middle"/>
                    </div>
                </template>
            </van-search>
        </van-sticky>
        <div v-if="isshow">
        <van-pull-refresh  v-model="isLoading" @refresh="onRefresh" style="height: calc(100vh - 60px); overflow: auto;">
            <van-list
                    v-model="loading"
                    :finished="finished"
                    finished-text="没有更多了"
                    @load="onLoad"
            >
                <div v-for="item in list" :key="item.newsId" :ref="item.newsId">
                <van-cell-group
                                class="zxlb">
                    <div class="newstime">
                        <span style="font-size: 20px">行情资讯</span>
                        <span @click="openScan(item.newsId)" style="float: right;padding: 5px 0 5px 10px"><van-icon name="share-o" size="20" /></span>
                        <span style="float: right;margin-top: 10px">{{item.auditTime}}</span>
                    </div>
                    <van-cell>
                        <div class="content" v-html="item.newsContent"></div>
                    </van-cell>
                    <div style="padding: 0 8px 10px 10px;height: 60px;text-align: left;">
                        <img src="../../assets/image/rhlogo.png" style="width: 100px;margin-top: 38px"/>
                        <img src="../../assets/image/rherw.jpg" style="width: 60px;float:right;"/>
                    </div>
                </van-cell-group>
                <van-divider :style="{ padding: '0 10px' }" />
                </div>
            </van-list>
        </van-pull-refresh>
        </div>


        <van-popup v-model="shareshow" round>
<!--            <img :src="imgtu" />-->
            <div style="font-size: 14px;line-height: 36px;padding-top: 10px;color: #969799">分享图片</div>
            <van-image
                    width="300"
                    :src="imgtu"
            />
            <div style="font-size: 14px;line-height: 36px;padding-bottom: 10px;color: #969799">长按图片保存到相册</div>
        </van-popup>
        <!--已弃用-->
        <van-popup v-model="showDetailCont" :style="{ height: '100%', width:'100%',overflow: 'hidden'}">
<!--            <van-nav-bar-->
<!--                    title="资讯内容"-->
<!--                    fixed-->
<!--                    left-arrow-->
<!--                    z-index="9000"-->
<!--                    @click-left="() => this.showDetailCont = false"-->
<!--            />-->
            <div class="searchwarp">
                <div class="van-cell-group van-hairline--top-bottom van-panel" style="border-bottom: 0">
                    <div class="van-cell van-panel__header">
                        <div class="van-cell__title">
                            <span>{{detailData.newsTitle}}</span>
                            <div class="van-cell__label">{{detailData.auditTime}}</div>
                        </div>
                    </div>
                    <div class="van-panel__content" style="line-height: 1.8">
                        <div v-html="detailData.newsContent"></div>
                        <div v-if="showAttach">附件下载:</div>
                        <div v-for="item in detailData.attaches" :key="item.newsAttachId">
                            <a :href="item.attachUrl"
                               style="color: #6685a4;font-size: 14px; padding: 12px 0;display: inline-block">{{item.attachName}}</a>
                        </div>
                    </div>

                </div>
            </div>
            <van-row gutter="20" style="margin-top:20px">
                <van-col span="8" offset="8">
                    <van-button block size="small" plain type="info" native-type="submit" class="button"
                                @click="() => this.showDetailCont = false">
                        关闭
                    </van-button>
                </van-col>
            </van-row>
        </van-popup>
    </div>
</template>

<script>
    import Vue from 'vue'
    import { CellGroup } from 'vant';
    Vue.use(CellGroup);
    import {
        Button,
        Calendar,
        Cell,
        Col,
        Divider,
        Field,
        Form,
        Grid,
        GridItem,
        Icon,
        Image as VanImage,
        ImagePreview,
        Lazyload,
        List,
        NavBar,
        Picker,
        Popup,
        PullRefresh,
        Radio,
        RadioGroup,
        Row,
        Search,
        Sticky,
        SwipeCell,
        Toast
    } from 'vant';
    import service from '../../server/index'
    import {resCode} from "../../utils/tools";
    // import wx from 'weixin-js-sdk';
    import html2canvas from 'html2canvas'
    Vue.use(Lazyload, {
        lazyComponent: true,
    });

    export default {
        name: "Fleet",
        components: {
            [NavBar.name]: NavBar,
            [Search.name]: Search,
            [List.name]: List,
            [Col.name]: Col,
            [Row.name]: Row,
            [Cell.name]: Cell,
            [SwipeCell.name]: SwipeCell,
            [Button.name]: Button,
            [Popup.name]: Popup,
            [Icon.name]: Icon,
            [Field.name]: Field,
            [PullRefresh.name]: PullRefresh,
            [Sticky.name]: Sticky,
            [RadioGroup.name]: RadioGroup,
            [Radio.name]: Radio,
            [Calendar.name]: Calendar,
            [Divider.name]: Divider,
            [VanImage.name]: VanImage,
            [ImagePreview.Component.name]: ImagePreview.Component,
            [Grid.name]: Grid,
            [GridItem.name]: GridItem,
            [Form.name]: Form,
            [Picker.name]: Picker
        },
        computed: {},
        data() {
            return {
                list: [],
                detailList: [],
                loading: true,
                finished: false,
                isLoading: false,
                page: 1,
                pageSize: 20,
                showDetailCont: false,
                detailData: {
                    newsContent: undefined,
                    newsTitle: undefined,
                    newsTypeName: undefined,
                    createPerson: undefined,
                    auditTime: undefined,
                    newsId: undefined,
                    attaches: [],
                },
                showAttach: false,
                key: '',
                imgtu:"",
                isshow:true,
                shareshow:false
            }
        },
        mounted() {
            this.onLoad();



        },

        methods: {
            showUrl(item) {
                console.log('item:  ', item.attachUrl)
            },
            openScan(newsId){
                console.log(newsId,this.$refs[newsId])
                html2canvas(this.$refs[newsId][0], {
                    useCORS: true,
                    backgroundColor: null
                })
                    .then(canvas => {

                        let  base64 = canvas.toDataURL('images/jpg')
                        console.log(base64)
                        this.imgtu=base64
                        this.shareshow=true
                        // this.savePicture(base64);
                    })




                // let params = {
                //     url: window.location.href.split("#")[0],
                //     appName:process.env.VUE_APP_NAME
                // }
                // service.getWxconfig(params).then((res)=>{
                //     // alert(JSON.stringify(res));
                //     if(res.code==200){
                //         wx.config({
                //             debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
                //             appId: res.data.appId, // 必填，公众号的唯一标识
                //             timestamp: res.data.timestamp, // 必填，生成签名的时间戳
                //             nonceStr: res.data.noncestr, // 必填，生成签名的随机串
                //             signature: res.data.signature,// 必填，签名
                //             jsApiList: ['updateAppMessageShareData','updateTimelineShareData'] // 必填，需要使用的JS接口列表
                //         });
                //
                //         wx.checkJsApi({
                //             jsApiList: ['updateTimelineShareData'], // 需要检测的JS接口列表，所有JS接口列表见附录2,
                //             success: function(res) {
                //                 // 以键值对的形式返回，可用的api值true，不可用为false
                //                 // 如：{"checkResult":{"chooseImage":true},"errMsg":"checkJsApi:ok"}
                //                 console.log("do wx checkJsApi",res)
                //             }
                //         });
                //
                //
                //         wx.ready(function () {//需在用户可能点击分享按钮前就先调用
                //             console.log("do wx ready")
                //             wx.updateTimelineShareData({
                //                 title: '行情资讯', // 分享标题
                //                 link: 'https://wechat.24991880.com/#/Home/SummaryList', // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                //                 desc: 'desc',
                //                 imgUrl: 'https://wechat.24991880.com/img/rherw.29fd564f.jpg', // 分享图标
                //                 success: function () {
                //                     // 设置成功
                //                     // alert("chengong")
                //                     Toast("分享成功")
                //                 }
                //             })
                //         });
                //
                //
                //         wx.error(function(res){
                //             console.log("wx error:",res)
                //             alert(res.errMsg);
                //             //config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
                //         });
                //
                //
                //     }
                // }).catch((res)=>{
                //     console.log("Catch",res);
                // });
            },



            onRefresh() {
                this.onLoad();
            },
            showDetail(newsId) {
                console.log(newsId)
                // 没有点击事件
                // this.showDetailCont = true
                // this.selNewsByIDG(newsId)
            },
            selNewsByIDG(newsId) {
                let param = {
                    newsId: newsId,
                    readPersonId: localStorage.getItem('userId'),
                }
                let url = process.env.VUE_APP_API+process.env.VUE_APP_NAME
                service.selNewsByIDG(url,param).then(res => {
                    if (res.code == resCode.success) {
                        this.detailData = res.data
                        if (res.data.attaches.length > 0) {
                            this.showAttach = true
                        } else {
                            this.showAttach = false
                        }
                    } else {
                        Toast(res.msg)
                    }
                })
            },
            back() {
                this.$router.replace("/Home/Search")
            },
            addPop() {
                this.show = true;
                this.addShowPop = true;
            },
            onSearch() {
                this.list = [];
                this.page = 1;
                this.onLoad();
            },
            onLoad() {
                this.selNewsG();
            },
            selNewsG() {
                let param = {
                    page: this.page,
                    count: this.pageSize,
                    ouid: process.env.VUE_APP_OUID,
                    newsTypeId: 2,
                    key: this.key,
                }
                let url = process.env.VUE_APP_API+process.env.VUE_APP_NAME
                service.selNewsG(url,param).then(res => {
                    if (res.code == resCode.success) {
                        if (res.data.length > 0) {
                            for (let i = 0; i < res.data.length; i++) {
                                this.list.push(res.data[i]);
                            }
                            this.page++
                        } else {
                            this.finished = true;
                        }
                        // 加载状态结束
                        this.loading = false;
                        this.isLoading = false;

                        // let _this=this
                        // setTimeout(function()  {
                        //
                        //     _this.openScan()//娃娃消失
                        //
                        // }, 2000);


                    } else {
                        this.loading = false;
                        this.finished = true;
                        this.isLoading = false;
                        Toast(res.msg)
                    }
                })
            },
        }
    }
</script>

<style scoped>
    .searchwarp {
        margin-top: 0px;
        height: calc(100vh - 70px);
        overflow: auto;
    }

    .van-list .van-cell__title {
        text-align: left;
    }

    /deep/ .van-cell__title {
        text-align: left;
        -webkit-box-flex: unset;
        -webkit-flex: unset;
        flex: unset;
    }

    .van-panel__content {
        padding: 10px 16px;
        text-align: left;
        font-size: 16px;
    }

    .zxlb::after {
        border-bottom: 1px solid #ebedf0;
    }

    .zxlb {
        margin: 0px 8px 20px 8px;
        overflow: hidden;
        border-radius: 8px;
        display: block;
        background:#f7f8fa url('../../assets/image/rhzxbg.png') no-repeat top;
        background-size: 100% 100%;
        border: 1px solid #6ea7af;

    }

    /deep/ .zxlb .van-cell {
        padding: 10px 10px 10px 10px;
        background: transparent;
    }

    .van-cell__value.van-cell__value--alone {
        background: #fff;
        padding: 8px 8px;
        border-radius: 8px;
    }

    .newstime {
        color: #fff;
        font-weight: normal;
        font-size: 12px;
        padding: 20px 0 8px 0;
        border-bottom: 1px solid rgba(255, 255, 255, 0.3);
        margin: 0 20px;
        vertical-align: bottom;
        text-align: left;
    }

    .van-cell::after {
        border-bottom: 0
    }
    .content >>> img{
        max-width: 100%;
    }
</style>
